export default __webpack_public_path__ + "static/media/keller-comp.92dc9b84.svg";